import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Card, Spin } from 'antd';
import { getOperationById } from '../api/operationsApi';

const { Title, Text } = Typography;

interface Operation {
  id: number;
  name: string;
  description: string;
}

const OperationDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [operation, setOperation] = useState<Operation | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadOperation = async () => {
      if (id) {
        try {
          const data = await getOperationById(parseInt(id));
          setOperation(data);
        } catch (error) {
          console.error('Error loading operation:', error);
        } finally {
          setLoading(false);
        }
      }
    };

    loadOperation();
  }, [id]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <Title level={2} style={{ marginBottom: '24px' }}>
        Detalle de Operación
      </Title>
      {operation ? (
        <Card title={operation.name} bordered>
          <Text>{operation.description}</Text>
        </Card>
      ) : (
        <Card title="Error" bordered>
          <Text>Operación no encontrada</Text>
        </Card>
      )}
    </div>
  );
};

export default OperationDetailPage;
